import type { Connection } from '@gdladder/shared/entities';
import type { UpdateConnectionRequest } from '@gdladder/shared/features';
import APIClient from '../APIClient';

type ConnectionListResponse = Partial<Omit<Connection, 'id' | 'appName' | 'accountName'>> &
    Pick<Connection, 'id' | 'appName' | 'accountName'>;

class ConnectionsClient {
    async connectAredl() {
        const res = await APIClient.post<Connection>('/connections/aredl');
        return res.data;
    }

    async list() {
        const res = await APIClient.get<Connection[]>('/connections');
        return res.data;
    }

    async listPublic(userId: number) {
        const res = await APIClient.get<ConnectionListResponse[]>(`/user/${userId}/connections`);
        return res.data;
    }

    async update(connectionId: string, options: UpdateConnectionRequest) {
        await APIClient.patch(`/connections/${connectionId}`, options);
    }

    async delete(connectionId: string) {
        await APIClient.delete(`/connections/${connectionId}`);
    }
}

export const connectionsClient = new ConnectionsClient();
